export const isPublicFillingPath = (pathname: string) =>
  /^\/candidate-onboarding\/[^/]+\/?$/.test(pathname) ||
  pathname === '/profile-completion';

export const isPublicFillingEndpoint = (url?: string) => {
  if (!url) return false;
  const pathname = new URL(
    url,
    typeof window === 'undefined' ? 'http://localhost' : window.location.origin,
  ).pathname;
  return (
    /^\/bff\/zy-hr\/onboarding-candidate\/[A-Za-z0-9_-]+(?:\/draft|\/submit)?$/.test(
      pathname,
    ) ||
    /^\/bff\/zy-hr\/onboarding-candidate\/[A-Za-z0-9_-]+\/files\/(?:upload|preview-url|download-url)$/.test(
      pathname,
    ) ||
    /^\/bff\/zy-hr\/profile-completion-candidate\/[A-Za-z0-9_-]{43}(?:\/submit)?$/.test(
      pathname,
    )
  );
};

export const isPublicFillingPage = isPublicFillingPath;
